import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DxButtonComponent, DxNumberBoxComponent } from 'devextreme-angular';
import moment from 'moment';
import { PARAMETRI_GIORNI_PRE_ALERT_ARTICOLI } from 'src/app/consts/const';
import { Articoli } from 'src/app/models/articoli';
import { Parametri } from 'src/app/models/parametri';
import { TipiArticoli } from 'src/app/models/tipi-articoli';
import { ArticoliConsegnatiScadenzeCompactComponent } from 'src/app/shared/components/articoli/articoli-consegnati-scadenze-compact/articoli-consegnati-scadenze-compact.component';
import { ChartBarConsumiMensiliArticoloComponent } from 'src/app/shared/components/articoli/chart-bar-consumi-mensili-articolo/chart-bar-consumi-mensili-articolo.component';
import { GridConsegneCompactComponent } from 'src/app/shared/components/articoli/grid-consegne-compact/grid-consegne-compact.component';
import { GridScadenzeArticoliCompactComponent } from 'src/app/shared/components/articoli/grid-scadenze-articoli-compact/grid-scadenze-articoli-compact.component';
import { GestArticoliBaseComponent } from 'src/app/shared/components/gest-articoli-base/gest-articoli-base.component';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import { MovimentiMagazzinoService } from 'src/app/shared/services/movimenti-magazzino.service';
import { MovimentoArticoliService } from 'src/app/shared/services/movimento-articoli.service';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import { ParametriService } from 'src/app/shared/services/parametri.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import { TipiArticoliService } from 'src/app/shared/services/tipi-articoli.service';
import { ConvertError } from 'src/app/utils/gestione-errori';
import { notificaMessaggio } from 'src/app/utils/notifiche-utils';

@Component({
  selector: 'app-articoli-dashboard',
  templateUrl: './articoli-dashboard.component.html',
  styleUrls: ['./articoli-dashboard.component.scss'],
  imports: [
    GridConsegneCompactComponent,
    DxButtonComponent,
    DxNumberBoxComponent,
    ArticoliConsegnatiScadenzeCompactComponent,
    GridScadenzeArticoliCompactComponent,
    ChartBarConsumiMensiliArticoloComponent,
  ],
})
export class ArticoliDashboardComponent
  extends GestArticoliBaseComponent
  implements OnInit
{
  private route = inject(ActivatedRoute);
  private storService = inject(StorageService);
  private navService = inject(NavigatorService);
  private articoloService = inject(ArticoliService);
  private tipiArticoloService = inject(TipiArticoliService);
  private parametriService = inject(ParametriService);
  private movService = inject(MovimentoArticoliService);
  private movimentiMagazzinoService = inject(MovimentiMagazzinoService);

  idArticolo: number;
  articolo: Articoli;
  isNew = false;
  descrArticolo: string;
  listTipiArticoli: TipiArticoli[];

  parametro: Parametri;
  giorniPreAlertArticoli = 0;

  consegneList: any[];
  listConsegneAlert: any[];
  consegneScadute: any[];
  consegneProssimeAllaScadenza: any[];
  numConsegneScadute: number;
  numConsegneProssimeAllaScadenza: number;

  tipoArticoloDescr: string;

  //Giacenze progressive
  daData: Date;
  aData: Date;
  giacenzeProgressive: any; //Grafico
  consegneMensili: any; //Grafico

  annoElaborazione: number = moment().year();

  constructor() {
    super();
    this.getParametro();
  }

  ngOnInit() {
    // Valorizzo date Chart Giacenze
    this.aData = moment().toDate();
    this.daData = moment().subtract(6, 'months').toDate();

    const idArticoloParam = this.route.snapshot.paramMap.get('id');
    if (!idArticoloParam || idArticoloParam == '0') {
      this.navService.goToHome();
    } else {
      this.loadTipiArticoli();

      this.idArticolo = +idArticoloParam;

      this.loadConsegne();
      //this.loadGiancenzeProgressive(); // Dati per chart giacenze progressive
      this.loadConsegneMensili(); // Dati per chart consegne mensili
    }
  }

  loadArticolo() {
    if (this.idArticolo > 0) {
      this.articoloService.get(this.idArticolo).subscribe({
        next: (res) => {
          if (res != null) {
            this.articolo = res;
            this.descrArticolo = res.descrizione;
            if (this.articolo.giacenza == null) {
              this.articolo.giacenza = 0;
            }

            this.tipoArticoloDescr = this.listTipiArticoli?.find(
              (x) => x.id == this.articolo.idTipo,
            ).descrizione;
          } else {
            notificaMessaggio('Articolo non presente', 'warning');
            this.navService.goToHome();
          }
        },
        error: (error) => {
          ConvertError(error, 'Errore recupero articolo');
        },
      });
    }
  }

  loadTipiArticoli() {
    this.tipiArticoloService.list().subscribe({
      next: (res) => {
        this.listTipiArticoli = res;
        this.loadArticolo();
      },
      error: (error) => {
        ConvertError(error, 'Errore recupero tipi articolo');
      },
    });
  }

  loadGiancenzeProgressive() {
    if (this.daData && this.aData && this.aData > this.daData) {
      this.movimentiMagazzinoService
        .giacenzeProgressive(this.idArticolo, this.daData, this.aData)
        .subscribe({
          next: (res) => {
            if (res != null) {
              this.giacenzeProgressive = res;
            }
          },
          error: (error) => {
            ConvertError(error, 'Errore recupero dati grafico giacenze');
          },
        });
    } else {
      notificaMessaggio('Verificare le date inserite', 'warning');
    }
  }

  loadConsegneMensili() {
    this.movimentiMagazzinoService
      .consegneMensili(this.annoElaborazione, this.idArticolo)
      .subscribe({
        next: (res) => {
          if (res != null) {
            this.consegneMensili = res;
          }
        },
        error: (error) => {
          ConvertError(error, 'Errore recupero dati grafico consegne mensili');
        },
      });
  }

  ricaricaDati() {
    this.loadConsegneMensili();
  }
  getParametro() {
    this.parametriService.get(PARAMETRI_GIORNI_PRE_ALERT_ARTICOLI).subscribe({
      next: (res) => {
        this.parametro = res;
        this.giorniPreAlertArticoli = this.parametro.valNum;
      },
      error: (error) => {
        ConvertError(error, 'Errore recupero parametro');
      },
    });
  }

  loadConsegne() {
    this.movService.listConsegne(0, this.idArticolo).subscribe({
      next: (res) => {
        this.consegneList = res.filter((x) => x.dipendenteAttivo); //Solo per dipendenti attivi

        const oggi = moment().format('YYYY-MM-DD'); // data odierna

        // Consegne scadute (datascadenza <= oggi)
        this.consegneScadute = this.consegneList.filter((c: any) => {
          const dataScadenza = moment(c.dataScadenza).format('YYYY-MM-DD');
          //return dataScadenza.isSameOrBefore(oggi, 'day');
          return dataScadenza <= oggi;
        });

        // Consegne prossime alla scadenza (entro x giorni da oggi)
        this.consegneProssimeAllaScadenza = this.consegneList.filter(
          (c: any) => {
            const dataScadenza = moment(c.dataScadenza).format('YYYY-MM-DD');
            //const diffGiorni = dataScadenza.diff(oggi, 'days');
            const diffGiorni = moment(dataScadenza).diff(moment(oggi), 'days');
            return diffGiorni > 0 && diffGiorni <= this.giorniPreAlertArticoli;
          },
        );

        //Unisco le liste
        this.listConsegneAlert = [
          ...this.consegneScadute,
          ...this.consegneProssimeAllaScadenza,
        ];

        this.numConsegneScadute = this.consegneScadute.length;
        this.numConsegneProssimeAllaScadenza =
          this.consegneProssimeAllaScadenza.length;
      },
      error: (error) => {
        ConvertError(error, 'Errore recupero consegne');
      },
    });
  }

  goToArticoloEdit() {
    this.navService.goToArticoliEdt(this.idArticolo); // reindirizzo alla pagina di edt dell'articolo
  }

  goToNuovaconsegna() {
    this.navService.goToNuovaConsegna(); // reindirizzo alla pagina per òa nuova consegna
  }
}
